import { createFileRoute } from '@tanstack/react-router';
import CandidatesShowTemplate from '@/features/agent/candidates/templates/CandidatesShowTemplate';
import type { TimelineFilter } from '@/features/agent/candidates/constants';

// タブ（profile / timeline / offer / matching / mypage）を検索パラメータで指定できるようにする。
// タブ状態はテンプレート側で useSearch により検索パラメータに追従して管理する。
type CandidatesShowSearch = {
  tab?: string;
  filter?: TimelineFilter;
};

export const Route = createFileRoute('/agent/candidates/$candidateProfileId/')({
  validateSearch: (search: Record<string, unknown>): CandidatesShowSearch => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    filter: search.filter === 'system' ? 'system' : undefined,
  }),
  component: CandidatesProfile,
});

function CandidatesProfile() {
  const { candidateProfileId } = Route.useParams();

  return <CandidatesShowTemplate id={candidateProfileId} />;
}
